module.exports = __webpack_public_path__ + "img/portfoliosite00.c187bb66.jpg";